import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { CompanyHistoricalDetailsRequest, CompanyHistoricalRequest } from "../models/request/companyHistoricalRequest";
import {
	CompanyHistoricalResponse,
	CompanyHistoricalDetailsResponse,
} from "@/main/models/response/companyHistoricalResponse";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { ICompanyHistoricalApi } from "@/main/api/base";

const baseRoute: string = "CompanyHistorical";

export class CompanyHistoricalApi extends ICompanyHistoricalApi {
	getHistorical(
		request: CompanyHistoricalRequest,
	): Promise<AxiosResponse<PaginationResponse<CompanyHistoricalResponse>>> {
		return api.get(`${baseRoute}`, { params: request });
	}

	getHistoricalDetails(
		request: CompanyHistoricalDetailsRequest,
	): Promise<AxiosResponse<Result<CompanyHistoricalDetailsResponse>>> {
		return api.get(`${baseRoute}/detail`, { params: request });
	}

	downloadHistoricalFile(guidFileImport: string): Promise<AxiosResponse<Result<string>>> {
		return api.get(`${baseRoute}/downloadHistoricalFile`, {
			params: { guidFileImport },
		});
	}
}
